<template>
  <va-navbar class="app-navbar">
    <header-selector slot="selector" :minimized.sync="minimizedProxy"/>

    <div slot="center" class="text-center">
      <span v-if="iconUrl">
        <img class="entity-logo" :src="iconUrl" alt="Entity Logo">
      </span>
      <span v-else class="i-evollu-gray"></span>
    </div>

    <div class="w-100 d-flex justify-content-end align-items-center">
      <!-- <color-dropdown class="va-navbar__item"/>
      <message-dropdown class="va-navbar__item"/>
      <notification-dropdown class="va-navbar__item"/> -->
      <!-- <settings-dropdown
        class="va-navbar__item"
        :navbar-view.sync="navbarViewProxy"/> -->
      <profile-dropdown class="va-navbar__item"></profile-dropdown>

      <language-dropdown class="va-navbar__item" ref="navbar_language_item"/>

      <!--<contact-dropdown class="va-navbar__item"></contact-dropdown>-->
    </div>
  </va-navbar>
</template>

<script>
import VaIconVuestic
  from 'vuestic-ui/src/components/vuestic-components/va-icon/va-iconset/VaIconVuestic'
import HeaderSelector from './components/HeaderSelector'
import LanguageDropdown from './components/dropdowns/LanguageDropdown'
import ProfileDropdown from './components/dropdowns/ProfileDropdown'
import NotificationDropdown from './components/dropdowns/NotificationDropdown'
import MessageDropdown from './components/dropdowns/MessageDropdown'
import SettingsDropdown from './components/dropdowns/SettingsDropdown'
import ColorDropdown from './components/dropdowns/ColorDropdown'
import ContactDropdown from './components/dropdowns/ContactDropdown'

export default {
  name: 'app-navbar',
  components: {
    SettingsDropdown,
    ColorDropdown,
    VaIconVuestic,
    HeaderSelector,
    MessageDropdown,
    NotificationDropdown,
    LanguageDropdown,
    ProfileDropdown,
    ContactDropdown
  },
  props: {
    minimized: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    minimizedProxy: {
      get () {
        return this.minimized
      },
      set (minimized) {
        this.$emit('update:minimized', minimized)
      },
    },
    iconUrl: function() {
      const user = this.$auth.user()
      if(user.entity.logo !== null) {
        return `${this.$store.state.evollauth_server}/entities/${user.entity.id}/icon`
      }
      return null
    }
  },
}
</script>

<style lang="scss">
.app-navbar {
  .i-evollu-gray {
    height: 16px;
  }

  .va-navbar__item {
    margin-top: 0px !important;
  }

}

.entity-logo {
  max-height: 50px !important;
}
</style>
